import type { ClinicalScopeT } from '../model/types';

/**
 * Display labels for each clinical scope type.
 */
export const CARE_STATE_SCOPE_LABEL: Record<ClinicalScopeT['type'], string> = {
  patient: 'Overview',
  problem: 'Problem',
  request: 'Request',
};
